import * as React from 'react'
import classNames from 'classnames'
import { LucideIcon, LucideIconName } from 'utils/lucideIcon'
import { CountingType } from 'capacity/types'
import { useTranslation } from 'translations'

const COUNTING_TYPES: CountingType[] = ['wholeTimeSlot', 'arrivalOnly']

const icon: Record<CountingType, LucideIconName> = {
    wholeTimeSlot: 'Gauge',
    arrivalOnly: 'DoorOpen',
}

interface CountingTypeCardsProps {
    value: CountingType
    onChange: (value: CountingType) => void
}

export function CountingTypeCards({ value, onChange }: CountingTypeCardsProps) {
    const { t } = useTranslation()
    return (
        <div className="capacity-counting-cards" role="group" aria-label={t('capacity.config.howItCountsQuestion')}>
            {COUNTING_TYPES.map((option) => {
                const selected = value === option
                return (
                    <button
                        key={option}
                        type="button"
                        className={classNames('capacity-counting-card', { selected })}
                        aria-pressed={selected}
                        onClick={() => onChange(option)}
                    >
                        <span className="capacity-counting-icon">
                            <LucideIcon iconName={icon[option]} size={22} />
                        </span>
                        <span className="capacity-counting-lead">{t(`capacity.config.counting.${option}.lead`)}</span>
                        <span className="capacity-counting-example">
                            {t(`capacity.config.counting.${option}.example`)}
                        </span>
                    </button>
                )
            })}
        </div>
    )
}
